<template>
  <div>
    <b-card no-body class="card-statistics mb-2">
      
      <b-card-header class="pb-0 pl-2">        
        <b-card-title class="mb-0">{{ platform.name }}</b-card-title>
        <router-link
          class="float-right"
          :to="{ name: 'bio-platform', params: { key: $route.params.key, platform_id: platform.id } }">Detaya Git</router-link>
      </b-card-header>
      <b-card-body class="statistics-body">
        <b-overlay :show="loadAnalysis" opacity="0.6" spinner-variant="primary" v-if="this.statisticsItems[0].title!=0">
          <b-row class="justify-content-between globalIst align-items-center">     
            <b-col v-for="item in filteredStatisticsItems" :key="item.icon" cols="auto">
              <b-media no-body class="d-flex">
                <b-media-aside>
                  <b-avatar size="48" :variant="item.color">
                    <feather-icon size="24" :icon="item.icon" />
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto text-center mt-1">
                  <h4 class="font-weight-bolder mb-0">{{ item.title }}</h4>
                  <b-card-text class="font-small-3 mb-0" v-html="item.subtitle"></b-card-text>
                </b-media-body>
              </b-media>
            </b-col>
          </b-row>
        </b-overlay>
        
        <b-row v-else-if="platform.has_bio">
          <b-col class="text-center">
            <b-card-text class="font-weight-bold">Mevcut paylaşımda veri bulunmuyor.</b-card-text>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col class="text-center">
            <b-card-text class="font-weight-bold">Platform ile ilgili paylaşım bulunamadı
              <b-button
                variant="primary"
                class="d-flex align-items-center justify-content-center"
                @click="$emit('add-trigger',platform_id)"> <FeatherIcon 
                size="18"
                icon="PlusSquareIcon"
                class="mr-1"
                ></FeatherIcon>Paylaşım Ekle</b-button>
            </b-card-text>
          </b-col>
        </b-row>
      </b-card-body>
      
    </b-card>
  </div>
</template>

<script>
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside,BAvatar , BMediaBody, BOverlay,
  BButton
} from 'bootstrap-vue'
import { platform } from 'chart.js'

export default {
  components: {
    BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside,BAvatar, BMediaBody, BButton, BOverlay
  },
  props: {
    linkId: {
      type: [String,Number],
      default:(null) 
    },
    infId: {
      type: Number,
      default:(null) 
    },
    type: {
      type: Number,
      default:(null) 
    },
    platform_id: {
      type: Number,
      default:(null) 
    },
    groupId: {
      type: Number,
      default:(null) 
    },
    platform: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: 'İstatikler'
    }
  },
  data() {
    return {
      statisticsItems: [
        { icon: 'SendIcon', color: 'light-info', title: null, subtitle: 'Ziyaret', customClass: 'mb-2 mb-xl-0' },
        { icon: 'ShoppingCartIcon', color: 'light-danger', title: null, subtitle: 'Sepete Ekleme', customClass: 'mb-2 mb-sm-0' },
        { icon: 'TrendingUpIcon', color: 'light-primary', title: null, subtitle: '', customClass: 'mb-2 mb-xl-0' },
        { icon: 'DollarSignIcon', color: 'light-success', title: null, subtitle: 'Ciro', customClass: '' }
      ],
      loadAnalysis: true,
    }
  },
  methods: {
    async getSummaryData() {
      try {
        this.loadAnalysis = true;
        let params = {}
        if(this.linkId){
          params['linkId'] = this.linkId
        }
        if(this.infId){
          params['infId'] = this.infId
        }
        if(this.type){
          params['type'] = this.type
        }
        if(this.platform){
          params['platform_id'] = this.platform.id
        }
        if(this.groupId){
          params['groupId'] = this.groupId
          this.statisticsItems[0].subtitle="Fenomen";
        }
        
        const baseUrl = 'analysis/summaryData';
        const response = await this.$http.get(baseUrl,{params});
        if (response.data.error) {
          console.error('Error:', response.data.error);
        } else {
          const data = response.data.data;

          // statisticsItems dizisini güncelle
          this.statisticsItems[0].title = data.global.event;        // event Adedi
          this.statisticsItems[1].title = data.global.cart;         // Cart

          // Sipariş aded, iç link ve dış link adedi
          const orderTotal = `
            ${data.global.order.total} Sipariş 
          `;
          this.statisticsItems[2].title = orderTotal;
          this.statisticsItems[2].subtitle = `${data.global.order.in_link+data.global.order.out_link} Ürün`;
          
          // Sipariş toplam tutarı, iç link ve dış link tutarları
          const priceTotal = `
            ${this.priceFormat(Math.ceil(data.global.price.total))}
          `;
          // this.statisticsItems[4].title'e ata
          this.statisticsItems[3].title = priceTotal;
          this.loadAnalysis = false;
        }


      } catch (error) {
        console.error('Veri alırken hata oluştu:', error);
      }
    },
    updateLastUpdatedTime() {
      const now = new Date();
      const diff = Math.floor((now - this.lastUpdateTime) / 60000); // Dakikalar
      this.lastUpdated = diff;
    },
    refreshData() {
      this.getSummaryData(); // Verileri yeniden yükle
    }
  },
  computed: {
    filteredStatisticsItems() {
      return this.$route.name === 'campaign-detail'
        ? this.statisticsItems.filter(item => item.subtitle !== 'Paylaşım')
        : this.statisticsItems;
    }
  },
  created() {
    this.getSummaryData(); // İlk yükleme
  },
}
</script>
<style>
@media screen and (max-width:1350px) {
  .globalIst > div >div {
      flex-direction: column !important;;
      justify-content: center;
      align-items: center;
  }


  .globalIst > div >div .media-aside {
      margin: 0;
      margin-bottom: 10px;
      align-self: initial !important;;
  }

  .globalIst > div >div h4 {
      font-size: 14px;
  }
}
</style>


